<template>
  <section>
    <h4>Booker Ranking</h4>
    <LoadingSpinner v-if="loading" />
    <div class="row my-1 px-2" v-if="!loading">
      <div class="px-3 pb-3 d-inline">
        <Tabs :tabs="(currentUser.role_id == 1 || currentUser.role_id == 9) ? tabs : filterTabs"
          @change="changeTab($event)" :tabSelected="tabSelected" />
      </div>

      <div class="col-12 px-1">
        <div class="row">
          <div class="col-md-3">
            <date-picker id="startDatePicker" class="" v-model="range.startDate" :config="datePickerConfig"
              placeholder="Start Date"></date-picker>
          </div>

          <div class="col-md-3">
            <date-picker id="endDatePicker" class="" v-model="range.endDate" :config="datePickerConfigEndDate"
              placeholder="End Date"></date-picker>
          </div>

          <div class="col-9 col-md-2">
            <button class="btn btn-success" @click="getData()" style="width: 100%" :disabled="loading">
              <i class="icon-calendar-check-o mr-2"></i>
              <small>
                {{ $t("lang.button.filter") }}
              </small>
            </button>
          </div>
        </div>
      </div>

      <!-- Dinamyc filters -->
      <div class="col-12 px-1 my-2" v-if="!loading">
        <div class="row">
          <div v-for="(filter, index) in dynamicFilters" :key="index" class="col-md-4 col-lg-4 mb-2">
            <div class="d-flex align-items-center">
              <select v-model="filter.field" @change="onFilterFieldChange(filter, index)"
                class="form-control form-control-sm mr-2" style="min-width: 150px;">
                <option v-for="field in availableFilterFields" :key="field.value" :value="field.value">
                  {{ field.label }}
                </option>
              </select>
              <!-- Filtro numérico (con operador superior/inferior) -->
              <template v-if="getFilterType(filter.field) !== 'select'">
                <select v-model="filter.operator" @change="applyFilters" class="form-control form-control-sm mr-2"
                  style="width: 100px;">
                  <option value=">=">
                    {{ $t("lang.label.greater_than_or_equal_to") }}
                  </option>
                  <option value="<=">
                    {{ $t("lang.label.less_than_or_equal_to") }}
                  </option>
                </select>
                <div class="d-flex align-items-center">
                  <input type="number" v-model.number="filter.value" @input="applyFilters"
                    class="form-control form-control-md" :placeholder="getFilterPlaceholder(filter.field)" step="any"
                    style="flex: 1;" />
                  <span v-if="getFilterType(filter.field) === 'percentage'" class="ml-1">%</span>
                </div>
              </template>
              <!-- Filtro select (Modality) -->
              <template v-else>
                <select v-model="filter.value" @change="applyFilters" class="form-control form-control-md">
                  <option value=""> {{ $t("lang.label.all") }}</option>
                  <option value="PART TIME">Part-time</option>
                  <option value="FULL TIME">Full-time</option>
                </select>
              </template>
              <button @click="removeFilter(index)" class="btn btn-sm btn-danger ml-2" style="padding: 0.25rem 0.5rem;">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="col-12 mb-2">
            <button @click="addFilter" class="btn btn-sm btn-primary">
              <i class="fa fa-plus mr-1"></i>
              {{ $t("lang.label.add_filter") }}
            </button>
            <button v-if="dynamicFilters.length > 0" @click="clearAllFilters" class="btn btn-sm btn-secondary ml-2">
              <i class="fa fa-trash mr-1"></i>
              {{ $t("lang.label.clear_filter") }}
            </button>
          </div>
        </div>
      </div>

      <!-- Tabla de datos -->
      <div class="col=12 w-100 my-1">
        <div class="row mt-3 mb-3">
          <div class="col-12">
            <!-- Muestro total de resultados de la consulta -->
            <!-- <span class="ml-1 mr-4 font-weight-bold">Result:
                <span v-if="orders.length > 0">{{ orders.length - 1}}</span>
                <span v-else>0</span>
              </span> -->

            <span class="ml-2">{{ $t("lang.label.orderby") }}:</span>

            <span class="mx-2">
              <select v-model="orderBy" @change="updateOrder" class="form-control">
                <option value="verified_tasks">{{ $t("lang.column.header_booker_ver_tks") }}</option>
                <option value="meetings_booked">{{ $t("lang.column.header_booker_meet_bk") }}</option>
                <option value="valid_meetings">{{ $t("lang.label.valid_meetings") }}</option>
                <option value="meetings_rate">{{ $t("lang.column.header_booker_meet_rt") }}</option>
                <option value="cold_meeting_rate">{{ $t("lang.column.header_booker_cold_mt") }}</option>
              </select>
            </span>

            <span class="mx-2">
              <select v-model="orderDirection" @change="updateOrder" class="form-control">
                <option value="asc">Asc</option>
                <option value="desc">Desc</option>
              </select>
            </span>
          </div>
        </div>

        <div class="mx-0 px-0 table-responsive table-sticky table-sticky-1col table-sticky-3col" v-if="!loading">
          <Table v-if="filteredUsers.length > 0" class="mx-2 w-100" :headers="headers" :cols="cols"
            :data="filteredUsers" :checkbox="false" :notselect="true" :model="model" :fieldsLoading="fieldsLoading"
            :key="key" @goToUser="goToUser">
          </Table>
          <div class="row" v-else>
            <div class="col-12 col-md-10 offset-md-1 text-center ">
              <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
                <h6>
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  No bookers to show
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService, bookersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import moment from "moment";

export default {
  name: "BookerRanking",
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
    isBookerManager() {
      return this.currentUser.role_id == 9;
    },

    filterTabs() {
      const status = this.currentUser.booker.status;
      let allowedTabNames = this.statusTabPermissions[status] || [];

      return Object.fromEntries(
        Object.entries(this.tabs).filter(
          ([_, tab]) =>
            allowedTabNames.includes(tab.name) &&
            !(["Stopped"].includes(tab.name) && this.currentUser.role_id !== 1)
        )
      );
    },
    filteredUsers() {
      if (!this.users || this.users.length === 0) {
        return [];
      }

      // Si no hay filtros activos, retornar todos los usuarios
      const activeFilters = this.dynamicFilters.filter(
        (f) => {
          if (!f.field) return false;
          // Para filtros de tipo select (Modality), considerar activo solo si tiene un valor seleccionado
          if (f.field === "hours_worked") {
            return f.value !== null && f.value !== undefined && f.value !== "";
          }
          // Para filtros numéricos, considerar activo si tiene valor
          return f.value !== null && f.value !== undefined && f.value !== "";
        }
      );

      if (activeFilters.length === 0) {
        return this.users;
      }

      // Aplicar filtros
      return this.users.filter((user) => {
        // Excluir la fila de totales del filtrado
        if (user.totalRow) {
          return true;
        }

        return activeFilters.every((filter) => {
          // Filtro especial para Modality (hours_worked)
          if (filter.field === "hours_worked") {
            if (!filter.value || filter.value === "") {
              return true; // Si no hay valor seleccionado, mostrar todos
            }
            // Si el filtro es "PART TIME", mostrar solo los que tienen "PART TIME"
            if (filter.value === "PART TIME") {
              return user.hours_worked === "PART TIME";
            }
            // Si el filtro es "FULL TIME", mostrar los que NO tienen "PART TIME"
            if (filter.value === "FULL TIME") {
              return user.hours_worked !== "PART TIME";
            }
            return true;
          }

          // Filtros numéricos
          const fieldValue = parseFloat(user[filter.field]) || 0;
          const filterValue = parseFloat(filter.value) || 0;

          if (filter.operator === ">=") {
            return fieldValue >= filterValue;
          } else if (filter.operator === "<=") {
            return fieldValue <= filterValue;
          }

          return true;
        });
      });
    },
    availableFilterFields() {
      return [
        { value: "days_since_status_change", label: "Active days", type: "number" },
        { value: "task_fake_qty", label: "Fake meetings", type: "number" },
        { value: "meetings_booked", label: "Meetings", type: "number" },
        { value: "verified_tasks", label: this.$t("lang.column.header_booker_ver_tks"), type: "number" },
        { value: "lost_meetings_prc", label: this.$t("lang.column.header_booker_lost_meet"), type: "percentage" },
        { value: "meetings_rate", label: this.$t("lang.column.header_booker_meet_rt"), type: "percentage" },
        { value: "pick_ups", label: this.$t("lang.column.header_booker_pick_ups"), type: "percentage" },
        { value: "hours_worked", label: this.$t("lang.column.header_booker_modality"), type: "select" },
      ];
    },
  },

  data() {
    return {
      key: 1,
      loading: true,
      statusTabPermissions: {
        "Booker Level 1": ["Level 1", "Level 2", "Level 3", "Level 4"],
        "Booker Level 2": ["Level 2", "Level 3", "Level 4"],
        "Level 3": ["Level 2", "Level 3", "Level 4"],
        "Level 4": ["Level 2", "Level 3", "Level 4"],
        "Booker Manager": ["Level 1", "Level 2", "Level 3", "Level 4", "Manager"],
        "Booker France": ["France"],
        "Booker Hivy": ["Hivy"],
        "Prosp Closing": ["Props. Closing"],
      },
      tabs: {
        4: {
          id: 4,
          name: "Level 1",
        },
        5: {
          id: 5,
          name: "Level 2",
        },
        6: {
          id: 15,
          name: "Level 3",
        },
        7: {
          id: 16,
          name: "Level 4",
        },
        8: {
          id: 6,
          name: "Manager",
        },
        9: {
          id: 7,
          name: "Stopped",
        },
        10: {
          id: 10,
          name: "France",
        },
        11: {
          id: 11,
          name: "Hivy",
        },
        12: {
          id: 14,
          name: "Props. Closing",
        },
      },
      tabSelected: 4,
      orderDirection: "desc",
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("month"),
      },
      range: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      users: [],
      linkComission: "/booker-commission",
      linkConsistency: "12",
      orderBy: "valid_meetings",
      filters: [],
      dynamicFilters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      showEmptyImage: false,
      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "rk_number",
          },
        ],
        [
          {
            value: "avatar",
            type: "image",
            width: "25px",
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToUser",
          },
        ],
        [
          {
            value: "id",
            type: "imageSetClients",
          },
        ],
        [
          {
            value: "user_bdr_status_id",
            value2: "days_since_status_change",
            value_label: "bdr_status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "Screening",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "2",
                label: "Onboarding",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "3",
                label: "Validated",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "4",
                label: "Level 1",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "5",
                label: "Booker Level 2",
                bgColor: "#FF8C00",
                textColor: "#FFFFFF",
              },
              {
                id: "6",
                label: "Booker Manager",
                bgColor: "#4B0082",
                textColor: "#FFFFFF",
              },
              {
                id: "7",
                label: "Stopped",
                bgColor: "#B22222",
                textColor: "#FFFFFF",
              },
              {
                id: "8",
                label: "Rejected",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "9",
                label: "Test",
                bgColor: "black",
                textColor: "#FFFFFF",
              },
              {
                id: "10",
                label: "Booker France",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "11",
                label: "Booker Hivy",
                bgColor: "yellow",
                textColor: "black",
              },
              {
                id: "14",
                label: "Props. Closing",
                bgColor: "#C6F505",
                textColor: "black",
              },
              {
                id: "15",
                label: "Booker Level 3",
                bgColor: "#279CF5",
                textColor: "#FFFFFF",
              },
              {
                id: "16",
                label: "Booker Level 4",
                bgColor: "#F5AD27",
                textColor: "#FFFFFF",
              },
              {
                id: "empty",
                label: "",
                bgColor: "white",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "hours_worked",
            show_text: "false",
            icons: [
              {
                icon_if_value: "PART TIME",
                icon_true: "icon-battery-half text-warning icon-small",
                tooltip_true: "PART TIME",
              },
              {
                icon_if_value: "FULL TIME",
                icon_true: "icon-battery text-success icon-small",
                tooltip_true: "FULL TIME",
              },
            ],
          },
        ],
        [
          {
            value: "verified_tasks",
          },
        ],
        [
          {
            value: "total_tasks",
          },
        ],
        [
          {
            value: "pick_ups",
            format: "percentage",
            type: "itemBadgeConditional",
            min: "min_r1",
          },
        ],
        [
          {
            value: "meetings_booked",
            // value2: "hasBonusLevel2",
            // format: "bonus",
            // type: "itemBadge"
          },
          {
            tooltip_icon: "icon-question-circle",
            condition: "has_appointment",
            value: "meetings_booked_tooltip",
            type: "tooltipNote"
          },
          {
            value: "has_fake",
            value3: "task_fake_qty",
            format: "fake",
            role: "role_id",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "FAKE",
                bgColor: "RED",
                textColor: "#FFFFFF",
              }
            ]
          },
          {
            value: "has_abusif",
            value3: "task_abusif_qty",
            format: "fake",
            role: "role_id",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "ABUSIF",
                bgColor: "ORANGE",
                textColor: "#FFFFFF",
              }
            ]
          }
        ],
        [
          {
            value: "valid_meetings",
            type: "colorByField",
            colorByField: "bonus_meeting",
            badgeClass: "badge badge-pill text-small font-weight-normal",
            colors: [
              { id: "1", bgColor: "transparent", textColor: "#000000" },
              { id: "2", bgColor: "#512da8", textColor: "#FFFFFF" },
              { id: "3", bgColor: "#D64D15", textColor: "#FFFFFF" },
              { id: "4", bgColor: "#FA765C", textColor: "#FFFFFF" },
            ],
          }
        ],
        [
          {
            value: "meetings_rate",
            format: "percentage",
          },
        ],
        [
          {
            value: "cold_meeting_rate",
            format: "percentage",
          },
        ],
        [
          {
            value: "consistency",
            format: "percentage",
            link: "linkConsistency",
            type: "link",
          },
        ],
        [
          {
            value: "adapted_fixed_salary",
            format: "money",
            simbol: "€",
            icon: "icon_sent-mail2.png",
            tooltip_value: "fixed_salary_tooltip",
            tooltip_icon: "fa-question-circle",
            canBeHidden: "yes"
          },
        ],
        [
          {
            value: "total_commission_meeting",
            link: "linkComission",
            type: "link",
            canBeHidden: "yes"
          },
        ],
        [
          {
            value: "abs_total_commission_meeting",
            value_qty: "abs_qty_commission_meeting",
            type: "withQty",
            symbol: "€",
          },
        ],
        [
          {
            value: "lost_meetings_prc",
            format: "percentage",
            type: "itemBadgeConditional",
            max: "max_r1",
            value3: "has_commision_bonus",
            canBeHidden: "yes"
          },
        ],
        [
          {
            value: "bonus_commission",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "1",
                label: "",
                bgColor: "transparent",
                textColor: "#000000",
              },
              {
                id: "2",
                label: "Com X2",
                bgColor: "#9ADD08",
                textColor: "#000000",
                fontSize: "10px",
                tooltipRowField: "bonus_commission_tooltip",
                tooltip: this.$t("lang.booker.bonus_commission_2", { bonus: 15 }),
              },
            ],
          },
          {
            value: "bonus_meeting",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "1",
                label: "",
                bgColor: "transparent",
                textColor: "#000000",
              },
              {
                id: "2",
                label: "Com X2",
                bgColor: "#512da8",
                textColor: "#FFFFFF",
                fontSize: "10px",
                tooltip: this.$t("lang.booker.bonus_meeting_2"),
              },
              {
                id: "3",
                label: "Com X3",
                bgColor: "#D64D15",
                textColor: "#FFFFFF",
                fontSize: "10px",
                tooltip: this.$t("lang.booker.bonus_meeting_3"),
              },
              {
                id: "4",
                label: "Com X4",
                bgColor: "#FA765C",
                textColor: "#FFFFFF",
                fontSize: "10px",
                tooltip: this.$t("lang.booker.bonus_meeting_4"),
              },
            ],
          },
        ],
        [
          {
            value: "coop_amount",
            value_qty: "coop_qty",
            type: "withQty",
            simbol: "€",
          },
        ],
        [
          {
            value: "booker_salary",
            format: "money",
            simbol: "€",
            canBeHidden: "yes"
          },
        ],
        [
          {
            value: "booker_revenue_generated",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "booker_gross_margin",
            format: "percentage",
          },
        ],
      ],
      headers: [
        {
          label: "RK",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Photo",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Name",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Clients",
          percentage: "22.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: "Status",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_modality"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_modality"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_ver_tks"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_ver_tks"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.tasks_done"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_pick_ups"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_pick_ups"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_meet_bk"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_meet_bk"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.label.valid_meetings"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.label.valid_meetings"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_meet_rt"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_meet_rt"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_cold_mt"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_cold_mt"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_consistency"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_consistency"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_fix_sal"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_fix_sal"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_commission"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_commission"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_abs_commission"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_booker_abs_content_commission"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_lost_meet"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_lost_meet"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Bonus",
          percentage: "12.5%",
          class: "overflowhide align-top",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },

        {
          label: this.$t("lang.column.header_booker_cooptation"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_bk_sal"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_bk_sal"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_revenue"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_revenue"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_gross"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_gross"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Tabs,
  },
  mounted() {
    if (this.currentUser.booker) {
      switch (this.currentUser.booker.status) {
        case "Booker France": this.tabSelected = 10;
          break;
        case "Hivy": this.tabSelected = 11;
          break;
        case "Prosp Closing": this.tabSelected = 14;
          break;
        case "Booker Level 2": this.tabSelected = 5;
          break;
        case "Level 3": this.tabSelected = 5;
          break;
        case "Level 4": this.tabSelected = 5;
          break;
        default: this.tabSelected = 4;
          break;
      }
    }
    this.getData("updateOrder");
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),

    changeTab(id) {
      if (this.tabSelected === id) return; //evitamos cargar info del mismo tab
      this.tabSelected = id;
      this.key++;
      this.getData();
    },
    updateOrder() {
      let rowTotals = [];
      if (this.users.length && this.users[this.users.length - 1].totalRow) {
        rowTotals = this.users.filter((el) => el.totalRow);

        this.users = this.users.filter((el) => !el.totalRow);
      } else {
        rowTotals = null;
      }

      this.users = this.users.slice().sort((a, b) => {
        // Obtener valores a comparar
        let propA = a[this.orderBy];
        let propB = b[this.orderBy];

        // Manejar valores nulos o no definidos
        if (propA === null || propA === undefined) propA = 0;
        if (propB === null || propB === undefined) propB = 0;

        // Convertir cadenas numéricas a números
        if (!isNaN(propA)) propA = Number(propA);
        if (!isNaN(propB)) propB = Number(propB);

        let result;

        // Comparar como números o como texto
        if (typeof propA === "number" && typeof propB === "number") {
          result = propA - propB; // Comparación numérica
        } else {
          result = propA.toString().localeCompare(propB.toString()); // Comparación textual
        }

        // Ajustar para orden descendente
        if (this.orderDirection === "desc") {
          result *= -1;
        }

        return result;
      });

      // Reasignar rk_number según el nuevo orden
      this.users.forEach((user, index) => {
        user.rk_number = index + 1;
      });

      // Volver a agregar la fila de totales si existía
      if (rowTotals) {
        this.users.push(...rowTotals);
      }
    },

    addLinksToUsers() {
      this.users = this.users.map((user) => ({
        ...user,
        linkComission: this.linkComission,
        linkConsistency: this.linkConsistency,
      }));
    },

    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getData(updateOrder = null) {
      this.loading = true;
      let type_role;
      type_role = this.currentUser.role_id == 1 ? 'ad' : this.currentUser.role_id == 2 ? 'bk' : 'ot';
      const { startDate, endDate } = this.range;
      const filters = {
        start_date: startDate,
        end_date: endDate,
        user_bdr_status_id: this.tabSelected,
        role: type_role,
      };
      bookersService.getBookerRanking(filters).then((response) => {
        if (response !== undefined) {
          //Calculos para resultados, para la ultima final
          if (response.result.length > 0) {
            const result = response.result;

            result.forEach((element) => {
              element.bonus_commission_tooltip =
                element.bdr_status === "Booker Manager"
                  ? this.$t("lang.booker.bonus_commission_2", { bonus: 20 })
                  : this.$t("lang.booker.bonus_commission_2", { bonus: 15 });

              if (this.currentUser.booker && this.currentUser.booker.user_id != element.id) {

                element.adapted_fixed_salary = 0
                element.total_commission_meeting = 0
                element.lost_meetings_prc = 0
                element.booker_salary = 0
                element.bonus_commission = '1'
                element.bonus_meeting = '1'
                element.show = 'no'

              } else {
                element.show = 'yes'
              }

              if (element.bonus_commission == '2') {
                element.has_commision_bonus = true;
              }

              if (Number(element.booker_gross_margin) < 0) {
                element.booker_gross_margin = '0'
              }
              element.role_id = this.currentUser.role_id;
              element.min_r1 = 5;
              element.max_r1 = 50;
              element.hasBonusLevel2 = false;
              //element.task_score_avg = element.task_score_avg ? parseFloat(element.task_score_avg).toFixed(1) : 0;

              if (element.bonus_meeting == 2) element.hasBonusLevel2 = true;

              if (element.meetings_booked < 1) {
                element.has_appointment = false;
                element.meetings_booked_tooltip = this.$t("lang.label.no_meetings_booked");
              } else {
                element.has_appointment = true;
                element.meetings_booked_tooltip = '';
              }

              if (element.has_avatar == 1) {
                let base64 = '';
                base64 = btoa(`usr-${element.id}`);
                element.avatar = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
              } else {
                element.avatar = require('@/assets/images/emptyperson.png');
              }

              if (element.consistency < 60) {
                element.salary_degrasivity = this.$t(
                  "lang.bdr.salarydegrasivity50prc"
                );
              } else if (element.consistency < 80) {
                element.salary_degrasivity = this.$t(
                  "lang.bdr.salarydegrasivity70prc"
                );
              }

              if (element.adapted_fixed_salary) {
                element.fixed_salary_tooltip = this.$t("lang.bdr.fixed_salary");
              } else {
                element.fixed_salary_tooltip = "";
              }

              if (element.task_fake_qty > 0 && element.task_fake_qty != null) {
                element.has_fake = 1;
              } else {
                element.has_fake = 0;
              }

              if (element.task_abusif_qty > 0 && element.task_abusif_qty != null) {
                element.has_abusif = 1;
              } else {
                element.has_abusif = 0;
              }

              // if(element.task_score_avg >= 1 && element.task_score_avg <= 3){
              //   element.minScore = 1;
              // }else if(element.task_score_avg >= 4 && element.task_score_avg <= 6){
              //   element.minScore = 4;
              // }else{
              //   element.minScore = 7;
              // }

              if (["4", "5"].includes(element.user_bdr_status_id)) {
                if (
                  element.verified_tasks >= 300 &&
                  element.verified_tasks < 600 &&
                  element.cold_meeting_rate == 0
                ) {
                  element.warning_icon = 1;
                } else if (
                  element.verified_tasks >= 600 &&
                  element.cold_meeting_rate == 0
                ) {
                  element.warning_icon = 2;
                }
                const today = new Date();
                const todayDay = today.getDate();
                if (
                  element.consistency < 15 &&
                  element.cold_meeting_rate == 0
                ) {
                  if (
                    (element.user_bdr_status_id == 4 &&
                      element.days_since_status_change >= 5 &&
                      element.days_since_status_change < 15) ||
                    ((element.days_since_status_change >= 30 || element.user_bdr_status_id == 5)
                      && todayDay >= 5 &&
                      todayDay < 15)
                  ) {
                    element.warning_icon = 3;
                  } else if (
                    (element.user_bdr_status_id == 4 &&
                      element.days_since_status_change >= 15 &&
                      element.days_since_status_change < 30) ||
                    ((element.days_since_status_change >= 30 || element.user_bdr_status_id == 5)
                      && todayDay >= 15)
                  ) {
                    element.warning_icon = 4;
                  }
                }
              }
            });



            const abs_total_commission_meeting = result.reduce(
              (sum, item) => sum + Number(item.abs_total_commission_meeting),
              0
            );

            const abs_qty_commission_meeting = result.reduce(
              (sum, item) => sum + Number(item.abs_qty_commission_meeting),
              0
            );

            const verified_tasks_total = result.reduce(
              (sum, item) => sum + Number(item.verified_tasks),
              0
            );
            const treated_opportunities_total = result.reduce(
              (sum, item) => sum + Number(item.treated_opportunities),
              0
            );
            const meetings_booked_total = result.reduce(
              (sum, item) => sum + Number(item.meetings_booked),
              0
            );

            const coop_amount_total = result.reduce(
              (sum, item) => sum + Number(item.coop_amount || 0),
              0
            );
            const valid_meetings_total = result.reduce(
              (sum, item) => sum + Number(item.valid_meetings || 0),
              0
            );

            const pick_ups_total =
              result
                .filter((el) => el.pick_ups)
                .reduce((sum, item) => sum + Number(item.pick_ups), 0) /
              result.filter((el) => el.pick_ups).length;

            const simple_meeting_rate =
              result
                .filter((el) => el.meetings_rate)
                .reduce((sum, item) => sum + Number(item.meetings_rate), 0) /
              result.filter((el) => el.meetings_rate).length;
            const simple_cold_meeting_rate =
              result
                .filter((el) => el.cold_meeting_rate)
                .reduce(
                  (sum, item) => sum + Number(item.cold_meeting_rate),
                  0
                ) / result.filter((el) => el.cold_meeting_rate).length;
            const simple_meetings_per_day =
              result
                .filter((el) => el.meetings_per_day)
                .reduce((sum, item) => sum + Number(item.meetings_per_day), 0) /
              result.filter((el) => el.meetings_per_day).length;

            const booker_salary_total = result.reduce(
              (sum, item) => sum + Number(item.booker_salary),
              0
            );

            const booker_tasks_done_total = result.reduce(
              (sum, item) => sum + Number(item.total_tasks),
              0
            );


            const booker_revenue_generated_total = result.reduce(
              (sum, item) => sum + Number(item.booker_revenue_generated),
              0
            );
            const simple_booker_gross_margin =
              ((booker_revenue_generated_total - booker_salary_total) /
                booker_revenue_generated_total) *
              100;
            const simple_consistency =
              result
                .filter((el) => el.consistency)
                .reduce((sum, item) => sum + Number(item.consistency), 0) /
              result.filter((el) => el.consistency).length;
            const fixed_salary_total = result.reduce(
              (sum, item) => sum + Number(item.adapted_fixed_salary),
              0
            );
            const total_commission_meeting_total = result.reduce(
              (sum, item) => sum + Number(item.total_commission_meeting),
              0
            );

            const filtered = result.map(el => ({
              ...el,
              lost_meetings_prc: el.lost_meetings_prc != null ? Number(el.lost_meetings_prc) : 0
            }));

            const count = filtered.length;

            const total_meetings_lost_rate = count > 0
              ? filtered.reduce((sum, item) => sum + item.lost_meetings_prc, 0) / count
              : 0;

            response.result = response.result.map((item, i) => {
              const rk_number = i + 1;
              return {
                ...item,
                bookerExpert: item.user_bdr_status_id,
                rk_number: rk_number,
              };
            });

            response.result = [
              ...response.result,
              {
                totalRow: true,
                avatar: "",
                email: "",
                id: "6123456",
                name: "",
                verified_tasks: verified_tasks_total,
                treated_opportunities: treated_opportunities_total,
                meetings_booked: meetings_booked_total,
                coop_amount: coop_amount_total.toFixed(2),
                valid_meetings: valid_meetings_total,
                meetings_rate: simple_meeting_rate.toFixed(2),
                cold_meeting_rate: simple_cold_meeting_rate.toFixed(2),
                meetings_per_day: simple_meetings_per_day.toFixed(2),
                booker_salary: booker_salary_total.toFixed(2),
                total_tasks: booker_tasks_done_total,
                booker_revenue_generated:
                  booker_revenue_generated_total.toFixed(2),
                booker_gross_margin: simple_booker_gross_margin.toFixed(2),
                consistency: simple_consistency.toFixed(2),
                adapted_fixed_salary: fixed_salary_total.toFixed(2),
                total_commission_meeting: total_commission_meeting_total,
                abs_total_commission_meeting: abs_total_commission_meeting,
                abs_qty_commission_meeting: abs_qty_commission_meeting,
                lost_meetings_prc: total_meetings_lost_rate.toFixed(2),
                pick_ups: pick_ups_total.toFixed(2),
                bdr_status: "empty",
                rk_number: "",
              },
            ];
            this.users = response.result;
            this.addLinksToUsers();
            if (updateOrder) {
              this.updateOrder();
            }
          }
          else {
            this.users = [];
          }
        }
        this.loading = false;
      });
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },
    goToUser(user_id) {
      if (this.currentUser.role_id == 1 || this.isBookerManager) {
        window.open("/users/" + user_id, "_blank");
      }
      return false;
    },
    addFilter() {
      // Obtener campos que no están siendo usados en filtros activos
      const usedFields = this.dynamicFilters.map((f) => f.field);
      const availableField = this.availableFilterFields.find(
        (field) => !usedFields.includes(field.value)
      );

      if (availableField) {
        const newFilter = {
          field: availableField.value,
          value: null,
        };

        // Solo agregar operator si no es un filtro de tipo select
        if (availableField.type !== "select") {
          newFilter.operator = ">=";
        }

        this.dynamicFilters.push(newFilter);
      } else {
        // Si todos los campos están en uso, agregar el primero disponible
        const firstField = this.availableFilterFields[0];
        const newFilter = {
          field: firstField.value,
          value: null,
        };

        if (firstField.type !== "select") {
          newFilter.operator = ">=";
        }

        this.dynamicFilters.push(newFilter);
      }
    },
    removeFilter(index) {
      this.dynamicFilters.splice(index, 1);
    },
    clearAllFilters() {
      this.dynamicFilters = [];
    },
    applyFilters() {
      // Los filtros se aplican automáticamente a través de la computed property filteredUsers
      // Este método se puede usar para forzar actualización si es necesario
      this.$forceUpdate();
    },
    getFilterLabel(field) {
      const filterField = this.availableFilterFields.find((f) => f.value === field);
      return filterField ? filterField.label : field;
    },
    getFilterType(field) {
      const filterField = this.availableFilterFields.find((f) => f.value === field);
      return filterField ? filterField.type : "number";
    },
    getFilterPlaceholder(field) {
      const filterType = this.getFilterType(field);
      if (filterType === "percentage") {
        return "Porcentaje";
      }
      return "Valor";
    },
    onFilterFieldChange(filter, index) {
      // Cuando se cambia el campo, resetear el valor y ajustar el operador si es necesario
      const fieldInfo = this.availableFilterFields.find((f) => f.value === filter.field);

      if (fieldInfo) {
        filter.value = null;

        // Si el nuevo campo es de tipo select, eliminar el operador
        if (fieldInfo.type === "select") {
          delete filter.operator;
        } else {
          // Si no es select y no tiene operador, agregarlo
          if (!filter.operator) {
            filter.operator = ">=";
          }
        }
      }

      this.applyFilters();
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
